const C = {
  name: "Finland",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 3V0H4V3C4 7.42228 7.57772 11 12 11V10.9645C12.1633 10.9879 12.3302 11 12.5 11C14.4323 11 16 9.43229 16 7.5H14C14 8.32771 13.3277 9 12.5 9C11.6723 9 11 8.32771 11 7.5C11 6.67228 11.6723 6 12.5 6V4C10.6296 4 9.10074 5.46896 9.00478 7.3156C8.68429 6.78675 8.5 6.16552 8.5 5.5C8.5 3.56228 10.0623 2 12 2V0C8.98893 0 6.55049 2.40754 6.50077 5.40654C6.17865 4.67014 6 3.85623 6 3Z" fill="currentColor"/>
<path d="M2 13H22V16C22 18.4198 20.2828 20.437 18 20.9001V24H16V19H17C18.6577 19 20 17.6577 20 16V15H10V24H8V18.4664C7.41196 18.8059 6.72903 19 6 19C3.78772 19 2 17.2123 2 15V13ZM6 17C7.10772 17 8 16.1077 8 15H4C4 16.1077 4.89228 17 6 17Z" fill="currentColor"/>
<path d="M14 17C14 17.55 13.55 18 13 18C12.45 18 12 17.55 12 17C12 16.45 12.45 16 13 16C13.55 16 14 16.45 14 17Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Finland
};
